// (A) 引入兩個 Layout
import FrontLayout from '@/layouts/FrontLayout.vue'
import AdminLayout from '@/layouts/AdminLayout.vue'
import { useAdminSysTempStore } from '@/store/adminSysTempStore.js'

import { createRouter, createWebHistory } from 'vue-router';
import HomePage from '@/views/HomePage.vue';
import AboutPage from '@/views/AboutPage.vue';
import Products from '@/views/Products.vue';
import ContactPage from '@/views/ContactPage.vue';
import Cart from '@/views/Cart.vue';
import LoginPage from '@/views/LoginPage.vue';
import Register from '@/views/Register.vue';
import Orders from '@/views/Orders.vue';
import ChangePassword from '@/views/ChangePassword.vue';
import LoginRes from '@/views/LoginRes.vue';
import MaskCare from '@/views/MaskCare.vue';
import SkincareTips from '@/views/SkincareTips.vue';
import ForgotPassword from '@/views/ForgotPassword.vue';
import Profile from '@/views/Profile.vue';
import Address from '@/views/Address.vue';
import ProductDetail from '@/views/ProductDetail.vue';
import Checkout from '@/views/Checkout.vue';
import CheckoutCvsResult from '@/views/CheckoutCvsResult.vue';
import PostersPage from '@/views/PostersPage.vue';
import PostersListPage from '@/views/PostersListPage.vue';
import SgsReportPage from '@/views/SgsReportPage.vue';
import PaymentSlip from '@/views/PaymentSlip.vue';
import PaymentCancelled from '@/views/PaymentCancelled.vue';

// ── 美容預約（前台）──────────────────────────────────
import BookingHome               from '@/views/booking/BookingHome.vue';
import BookingAnnouncements      from '@/views/booking/BookingAnnouncements.vue';
import BookingAnnouncementDetail from '@/views/booking/BookingAnnouncementDetail.vue';
import StoreApply     from '@/views/booking/StoreApply.vue';
// ── 店家後台 ─────────────────────────────────────────
import StoreAdminLayout      from '@/layouts/StoreAdminLayout.vue';
import StoreAdminLogin          from '@/views/store-admin/StoreAdminLogin.vue'
import StoreAdminForgotPassword from '@/views/store-admin/StoreAdminForgotPassword.vue'
import StoreAdminResetPassword  from '@/views/store-admin/StoreAdminResetPassword.vue';
import StoreAdminDashboard   from '@/views/store-admin/StoreAdminDashboard.vue';
import StoreAdminServices    from '@/views/store-admin/StoreAdminServices.vue';
import StoreAdminSlots       from '@/views/store-admin/StoreAdminSlots.vue';
import StoreAdminReservations from '@/views/store-admin/StoreAdminReservations.vue';
import StoreAdminHours        from '@/views/store-admin/StoreAdminHours.vue';
import StoreAdminProfile      from '@/views/store-admin/StoreAdminProfile.vue';
import StoreAdminGuide           from '@/views/store-admin/StoreAdminGuide.vue';
import StoreAdminAnnouncements       from '@/views/store-admin/StoreAdminAnnouncements.vue';
import StoreAdminAnnouncementDetail  from '@/views/store-admin/StoreAdminAnnouncementDetail.vue';
import BookingStore    from '@/views/booking/BookingStore.vue';
import BookingReserve  from '@/views/booking/BookingReserve.vue';
import BookingSuccess     from '@/views/booking/BookingSuccess.vue';
import BookingQuery       from '@/views/booking/BookingQuery.vue';
import BookingVerifyError from '@/views/booking/BookingVerifyError.vue';
import MemberReservations from '@/views/member/MemberReservations.vue';

import PrivacyPolicy from '@/components/PrivacyPolicy.vue';
import TermsOfService from '@/components/TermsOfService.vue';
import ProductReturns from '@/components/ProductReturns.vue';
import PartnerInquiry from '@/components/PartnerInquiry.vue';

import AdminUsers from '@/views/admin/AdminUsers.vue';
import AdminOrders from '@/views/admin/AdminOrders.vue';
import AdminLogin from '@/views/admin/AdminLogin.vue';
import AdminProducts from '@/views/admin/AdminProducts.vue';
import AdminAdminNotifications from '@/views/admin/AdminNotifications.vue';
import AdminDashboard  from '@/views/admin/AdminDashboard.vue';
import AdminHomeImages from '@/views/admin/AdminHomeImages.vue';
import AdminHtmlPages from '@/views/admin/AdminHtmlPages.vue';
import AdminPosters from '@/views/admin/AdminPosters.vue';
import AdminHtmlImages from '@/views/admin/AdminHtmlImages.vue';
import AdminSettings from '@/views/admin/AdminSettings.vue';
import AdminImages from '@/views/admin/AdminImages.vue';
import AdminBookingStores       from '@/views/admin/AdminBookingStores.vue';
import AdminBookingReservations from '@/views/admin/AdminBookingReservations.vue';
import AdminBookingServices     from '@/views/admin/AdminBookingServices.vue';
import AdminAnnouncements       from '@/views/admin/AdminAnnouncements.vue';
import AdminAnnouncementDetail  from '@/views/admin/AdminAnnouncementDetail.vue';
import AdminCoupons             from '@/views/admin/AdminCoupons.vue';
import AdminCampaigns           from '@/views/admin/AdminCampaigns.vue';
import AdminPromotions          from '@/views/admin/AdminPromotions.vue';
import AdminAffiliates          from '@/views/admin/AdminAffiliates.vue';
import AdminAffiliatePayouts    from '@/views/admin/AdminAffiliatePayouts.vue';
// ── 合作夥伴（前台）──────────────────────────────────
import AffiliateApply           from '@/views/affiliate/AffiliateApply.vue';
import AffiliateLogin           from '@/views/affiliate/AffiliateLogin.vue';
import AffiliateDashboard       from '@/views/affiliate/AffiliateDashboard.vue';
import AffiliateForgotPassword  from '@/views/affiliate/AffiliateForgotPassword.vue';
import AffiliateResetPassword   from '@/views/affiliate/AffiliateResetPassword.vue';

import EditorHtml from '@/components/EditorHtml.vue';
// import { useVersionStore } from '@/store/versionStore'

// 統一 BASE 網址，給 canonical 用
const BASE_URL = 'https://jiliskin.com';

const routes = [
  // ── 店家入駐申請（獨立頁面，不走 FrontLayout）──────
  {
    path: '/store-apply',
    name: 'StoreApply',
    component: StoreApply,
    meta: { title: 'JiLi | 店家線上預約系統申請', hideNavFooter: true }
  },
  // ── 店家後台登入（獨立頁面，不走 StoreAdminLayout）──
  {
    path: '/store-admin/login',
    name: 'StoreAdminLogin',
    component: StoreAdminLogin,
    meta: { title: 'JiLi | 店家後台登入' }
  },
  {
    path: '/store-admin/forgot-password',
    name: 'StoreAdminForgotPassword',
    component: StoreAdminForgotPassword,
    meta: { title: 'JiLi | 店家後台 - 忘記密碼' }
  },
  {
    path: '/store-admin/reset-password',
    name: 'StoreAdminResetPassword',
    component: StoreAdminResetPassword,
    meta: { title: 'JiLi | 店家後台 - 重設密碼' }
  },
  // ── 店家後台（需 JWT，走 StoreAdminLayout）──────────
  {
    path: '/store-admin',
    component: StoreAdminLayout,
    children: [
      { path: '',           redirect: 'guide' },
      {
        path: 'dashboard',
        name: 'StoreAdminDashboard',
        component: StoreAdminDashboard,
        meta: { title: 'JiLi | 店家後台 - 儀表板' }
      },
      {
        path: 'services',
        name: 'StoreAdminServices',
        component: StoreAdminServices,
        meta: { title: 'JiLi | 店家後台 - 服務管理' }
      },
      {
        path: 'slots',
        name: 'StoreAdminSlots',
        component: StoreAdminSlots,
        meta: { title: 'JiLi | 店家後台 - 時段管理' }
      },
      {
        path: 'reservations',
        name: 'StoreAdminReservations',
        component: StoreAdminReservations,
        meta: { title: 'JiLi | 店家後台 - 預約管理' }
      },
      {
        path: 'hours',
        name: 'StoreAdminHours',
        component: StoreAdminHours,
        meta: { title: 'JiLi | 店家後台 - 營業時間' }
      },
      {
        path: 'profile',
        name: 'StoreAdminProfile',
        component: StoreAdminProfile,
        meta: { title: 'JiLi | 店家後台 - 店家資料' }
      },
      {
        path: 'guide',
        name: 'StoreAdminGuide',
        component: StoreAdminGuide,
        meta: { title: 'JiLi | 店家後台 - 操作指南' }
      },
      {
        path: 'announcements',
        name: 'StoreAdminAnnouncements',
        component: StoreAdminAnnouncements,
        meta: { title: 'JiLi | 店家後台 - 平台公告' }
      },
      {
        path: 'announcements/:id',
        name: 'StoreAdminAnnouncementDetail',
        component: StoreAdminAnnouncementDetail,
        meta: { title: 'JiLi | 店家後台 - 公告詳細' }
      },
    ]
  },
  {
    path: '/editor',
    name: 'EditorHtml',
    component: EditorHtml,
    meta: {
      title: 'editor'
      // 後台 / 編輯頁一般不需要 canonical
    }
  },
  {
    path: '/admin',
    component: AdminLayout, // ★ 後台 Layout
    children: [
      {
        path: '',
        name: 'AdminDashboard',
        component: AdminDashboard,
        meta: { title: 'JiLi | 管理者介面 - 概覽' }
      },
      {
        path: 'users',
        name: 'AdminUsers',
        component: AdminUsers,
        meta: { title: 'JiLi | 管理者介面 - 會員管理' }
      },
      {
        path: 'orders',
        name: 'AdminOrders',
        component: AdminOrders,
        meta: { title: 'JiLi | 管理者介面 - 訂單管理' }
      },
      {
        path: 'login',
        name: 'AdminLogin',
        component: AdminLogin,
        meta: { title: 'JiLi | 管理者介面 - 登入' }
      },
      {
        path: 'products',
        name: 'AdminProducts',
        component: AdminProducts,
        meta: { title: 'JiLi | 管理者介面 - 商品管理' }
      },
      {
        path: 'notifications',
        name: 'AdminAdminNotifications',
        component: AdminAdminNotifications,
        meta: { title: 'JiLi | 管理者介面 - 通知管理' }
      },
      {
        path: 'homeImages',
        name: 'AdminHomeImages',
        component: AdminHomeImages,
        meta: { title: 'JiLi | 管理者介面 - 首頁圖片' }
      },
      {
        path: 'htmlpages',
        name: 'AdminHtmlPages',
        component: AdminHtmlPages,
        meta: { title: 'JiLi | 管理者介面 - 文章管理' }
      },
      {
        path: 'htmlimages',
        name: 'AdminHtmlImages',
        component: AdminHtmlImages,
        meta: { title: 'JiLi | 管理者介面 - 文章圖片' }
      },
      {
        path: 'adposters',
        name: 'AdminPosters',
        component: AdminPosters,
        meta: { title: 'JiLi | 管理者介面 - 海報管理' }
      },
      {
        path: 'settings',
        name: 'AdminSettings',
        component: AdminSettings,
        meta: { title: 'JiLi | 管理者介面 - 相關設置' }
      },
      {
        path: 'images',
        name: 'AdminImages',
        component: AdminImages,
        meta: { title: 'JiLi | 管理者介面 - 圖片管理' }
      },
      // ── 美容預約管理（平台管理員）──────────────────
      {
        path: 'booking-stores',
        name: 'AdminBookingStores',
        component: AdminBookingStores,
        meta: { title: 'JiLi | 管理者介面 - 店家管理' }
      },
      {
        path: 'booking-reservations',
        name: 'AdminBookingReservations',
        component: AdminBookingReservations,
        meta: { title: 'JiLi | 管理者介面 - 預約總覽' }
      },
      {
        path: 'booking-services',
        name: 'AdminBookingServices',
        component: AdminBookingServices,
        meta: { title: 'JiLi | 管理者介面 - 服務項目管理' }
      },
      {
        path: 'announcements',
        name: 'AdminAnnouncements',
        component: AdminAnnouncements,
        meta: { title: 'JiLi | 管理者介面 - 公告管理' }
      },
      {
        path: 'announcements/:id',
        name: 'AdminAnnouncementDetail',
        component: AdminAnnouncementDetail,
        meta: { title: 'JiLi | 管理者介面 - 公告詳細' }
      },
      {
        path: 'coupons',
        name: 'AdminCoupons',
        component: AdminCoupons,
        meta: { title: 'JiLi | 管理者介面 - 折扣券管理' }
      },
      {
        path: 'campaigns',
        name: 'AdminCampaigns',
        component: AdminCampaigns,
        meta: { title: 'JiLi | 管理者介面 - 活動管理' }
      },
      {
        path: 'promotions',
        name: 'AdminPromotions',
        component: AdminPromotions,
        meta: { title: 'JiLi | 管理者介面 - 活動公告管理' }
      },
      {
        path: 'affiliates',
        name: 'AdminAffiliates',
        component: AdminAffiliates,
        meta: { title: 'JiLi | 管理者介面 - 合作夥伴管理' }
      },
      {
        path: 'affiliate-payouts',
        name: 'AdminAffiliatePayouts',
        component: AdminAffiliatePayouts,
        meta: { title: 'JiLi | 管理者介面 - 提領申請管理' }
      }
    ]
  },
  {
    path: '',
    component: FrontLayout, // ★ 前台 Layout
    children: [
      {
        path: '',
        name: 'home',
        component: HomePage,
        meta: {
          title: 'JiLi | 極致奢華護膚，來自自然的珍貴呵護',
          canonical: `${BASE_URL}/`
        }
      },
      {
        path: 'about',
        name: 'about',
        component: AboutPage,
        meta: {
          title: 'JiLi | 關於我們',
          canonical: `${BASE_URL}/about`
        }
      },
      {
        path: 'products',
        name: 'products',
        component: Products,
        meta: {
          title: 'JiLi | 產品列表',
          canonical: `${BASE_URL}/products`
        }
      },
      {
        path: 'product/:id',
        name: 'ProductDetail',
        component: ProductDetail,
        meta: {
          title: 'JiLi | 產品'
          // canonical 動態由 afterEach 透過 to.path 自動產生
        }
      },
      {
        path: 'contact',
        name: 'ContactPage',
        component: ContactPage,
        meta: {
          title: 'JiLi | 聯絡我們',
          canonical: `${BASE_URL}/contact`
        }
      },
      {
        path: 'cart',
        name: 'cart',
        component: Cart,
        meta: {
          title: 'JiLi | 購物車',
          canonical: `${BASE_URL}/cart`
        }
      },
      {
        path: 'checkout',
        name: 'checkout',
        component: Checkout,
        meta: {
          title: 'JiLi | 結帳',
          canonical: `${BASE_URL}/checkout`
        }
      },
      {
        path: 'login',
        name: 'LoginPage',
        component: LoginPage,
        meta: {
          title: 'JiLi | 登入',
          canonical: `${BASE_URL}/login`
        }
      },
      {
        path: 'loginres',
        name: 'loginres',
        component: LoginRes,
        meta: {
          title: 'JiLi | 登入LINE',
          canonical: `${BASE_URL}/loginres`
        }
      },
      {
        path: 'register',
        name: 'register',
        component: Register,
        meta: {
          title: 'JiLi | 註冊',
          canonical: `${BASE_URL}/register`
        }
      },
      {
        path: 'profile',
        name: 'Profile',
        component: Profile,
        meta: {
          title: 'JiLi | 更新資料',
          canonical: `${BASE_URL}/profile`
        }
      },
      {
        path: 'address',
        name: 'address',
        component: Address,
        meta: {
          title: 'JiLi | 寄件地址',
          canonical: `${BASE_URL}/address`
        }
      },
      {
        path: 'cpassword',
        name: 'cpassword',
        component: ChangePassword,
        meta: {
          title: 'JiLi | 密碼更改',
          canonical: `${BASE_URL}/cpassword`
        }
      },
      {
        path: 'fpassword',
        name: 'fpassword',
        component: ForgotPassword,
        meta: {
          title: 'JiLi | 忘記密碼',
          canonical: `${BASE_URL}/fpassword`
        }
      },
      {
        path: 'orders',
        name: 'orders',
        component: Orders,
        meta: {
          title: 'JiLi | 訂單查詢',
          canonical: `${BASE_URL}/orders`
        }
      },
      {
        path: 'privacypolicy',
        name: 'PrivacyPolicy',
        component: PrivacyPolicy,
        meta: {
          title: 'JiLi | 隱私政策',
          canonical: `${BASE_URL}/privacypolicy`
        }
      },
      {
        path: 'termsofservice',
        name: 'TermsOfService',
        component: TermsOfService,
        meta: {
          title: 'JiLi | 服務條款',
          canonical: `${BASE_URL}/termsofservice`
        }
      },
      {
        path: 'productreturns',
        name: 'productreturns',
        component: ProductReturns,
        meta: {
          title: 'JiLi | 商品退換貨',
          canonical: `${BASE_URL}/productreturns`
        }
      },
      {
        path: 'partnerinquiry',
        name: 'partnerinquiry',
        component: PartnerInquiry,
        meta: {
          title: 'JiLi | 合作夥伴接洽',
          canonical: `${BASE_URL}/partnerinquiry`
        }
      },
      {
        path: 'maskCare',
        name: 'maskCare',
        component: MaskCare,
        meta: {
          title: 'JiLi | 面膜小知識',
          canonical: `${BASE_URL}/maskCare`
        }
      },
      {
        path: 'sgs-report/:product',
        name: 'SgsReportPage',
        component: SgsReportPage,
        meta: { title: 'SGS 檢驗報告 | JiLi' },
      },
      {
        path: 'posters',
        name: 'PostersListPage',
        component: PostersListPage,
        meta: {
          title: 'JiLi | 保養知識',
          canonical: `${BASE_URL}/posters`
        }
      },
      {
        path: 'posters/:id',
        name: 'PostersPage',
        component: PostersPage,
        meta: {
          title: 'JiLi | 保養知識'
          // canonical 動態由 afterEach 透過 to.path 自動產生
        }
      },
      {
        path: 'skincareTips',
        name: 'skincareTips',
        component: SkincareTips,
        meta: {
          title: 'JiLi | 保養小技巧',
          canonical: `${BASE_URL}/skincareTips`
        }
      },
      {
        path: 'paymentSlip',
        name: 'PaymentSlip',
        component: PaymentSlip,
        meta: {
          title: 'JiLi | 繳款單',
          canonical: `${BASE_URL}/paymentSlip`
        }
      },
      {
        path: 'payment-cancelled',
        name: 'PaymentCancelled',
        component: PaymentCancelled,
        meta: {
          title: 'JiLi | 付款未完成'
        }
      },
      {
        path: 'checkoutCvsResult',
        name: 'CheckoutCvsResult',
        component: CheckoutCvsResult,
        meta: {
          title: 'JiLi | 手機版店到店回傳',
          canonical: `${BASE_URL}/checkoutCvsResult`
        }
      },

      // ── 美容預約（前台）────────────────────────────
      {
        path: 'booking',
        name: 'BookingHome',
        component: BookingHome,
        meta: {
          title: 'JiLi | 美容預約',
          canonical: `${BASE_URL}/booking`,
          hideNavFooter: true
        }
      },
      {
        path: 'booking/stores/:id',
        name: 'BookingStore',
        component: BookingStore,
        meta: { title: 'JiLi | 店家詳情', hideNavFooter: true }
      },
      {
        path: 'booking/stores/:id/reserve',
        name: 'BookingReserve',
        component: BookingReserve,
        meta: { title: 'JiLi | 填寫預約資料', hideNavFooter: true }
      },
      {
        path: 'booking/success',
        name: 'BookingSuccess',
        component: BookingSuccess,
        meta: { title: 'JiLi | 預約成功', hideNavFooter: true }
      },
      {
        path: 'booking/query',
        name: 'BookingQuery',
        component: BookingQuery,
        meta: {
          title: 'JiLi | 查詢預約',
          canonical: `${BASE_URL}/booking/query`,
          hideNavFooter: true
        }
      },
      {
        path: 'booking/verify-error',
        name: 'BookingVerifyError',
        component: BookingVerifyError,
        meta: { title: 'JiLi | 驗證失敗', hideNavFooter: true }
      },
      {
        path: 'booking/announcements',
        name: 'BookingAnnouncements',
        component: BookingAnnouncements,
        meta: { title: 'JiLi | 平台公告', hideNavFooter: true, requiresStoreAuth: true }
      },
      {
        path: 'booking/announcements/:id',
        name: 'BookingAnnouncementDetail',
        component: BookingAnnouncementDetail,
        meta: { title: 'JiLi | 公告詳細', hideNavFooter: true, requiresStoreAuth: true }
      },

      // ── 會員預約列表（與訂單、個人資料同層）──────
      {
        path: 'member/reservations',
        name: 'MemberReservations',
        component: MemberReservations,
        meta: {
          title: 'JiLi | 我的預約',
          canonical: `${BASE_URL}/member/reservations`
        }
      },

      // ── 合作夥伴（前台，隱藏 Nav/Footer）──────────
      {
        path: 'affiliate/apply',
        name: 'AffiliateApply',
        component: AffiliateApply,
        meta: { title: 'JiLi | 合作夥伴申請', hideNavFooter: true }
      },
      {
        path: 'affiliate/login',
        name: 'AffiliateLogin',
        component: AffiliateLogin,
        meta: { title: 'JiLi | 合作夥伴登入', hideNavFooter: true }
      },
      {
        path: 'affiliate/dashboard',
        name: 'AffiliateDashboard',
        component: AffiliateDashboard,
        meta: { title: 'JiLi | 合作夥伴後台', hideNavFooter: true }
      },
      {
        path: 'affiliate/forgot-password',
        name: 'AffiliateForgotPassword',
        component: AffiliateForgotPassword,
        meta: { title: 'JiLi | 合作夥伴 - 忘記密碼', hideNavFooter: true }
      },
      {
        path: 'affiliate/reset-password',
        name: 'AffiliateResetPassword',
        component: AffiliateResetPassword,
        meta: { title: 'JiLi | 合作夥伴 - 重設密碼', hideNavFooter: true }
      }
    ]
  }
];

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes,
  scrollBehavior() {
    // 無論去哪一頁都捲到最上方
    return { top: 0 };
  }
});

// 切換路由前：處理 body class（有沒有 navbar）
// 不需要驗證的路由名稱
const STORE_ADMIN_PUBLIC = ['StoreAdminLogin', 'StoreAdminForgotPassword', 'StoreAdminResetPassword']
const ADMIN_PUBLIC       = ['AdminLogin']

router.beforeEach(async (to, from, next) => {
  document.body.classList.remove('has-navbar');
  document.body.classList.remove('no-navbar');

  // /admin 與 /editor 頁面不顯示前台 navbar
  if (to.path.startsWith('/admin') || to.path.startsWith('/editor') || to.path.startsWith('/store-admin')) {
    document.body.classList.add('no-navbar');
  } else {
    document.body.classList.add('has-navbar');
  }

  // ── 店家後台 guard（JWT token）──────────────────────────
  const needsStoreAuth =
    (to.path.startsWith('/store-admin') && !STORE_ADMIN_PUBLIC.includes(to.name)) ||
    to.meta.requiresStoreAuth

  if (needsStoreAuth) {
    const token = localStorage.getItem('store_admin_token')
    if (!token) {
      return next({ name: 'StoreAdminLogin' })
    }
  }

  // ── 主後台 guard（session）──────────────────────────────
  if (to.path.startsWith('/admin') && !ADMIN_PUBLIC.includes(to.name)) {
    const adminStore = useAdminSysTempStore()
    if (!adminStore.isLoggedIn) {
      await adminStore.fetchAdminCheckLogin()
      if (!adminStore.isLoggedIn) {
        return next({ name: 'AdminLogin' })
      }
    }
  }

  next();
});

// 切換路由後：設定 title + canonical + 清除 no-scroll
router.afterEach((to) => {
  // 1) 設定標題（如果之後要用 versionStore 再把下面改回來）
  if (to.meta && to.meta.title) {
    document.title = to.meta.title;
    // const versionStore = useVersionStore()
    // const settings = await versionStore.getSettings()
    // if (settings) {
    //   document.title = settings.COMPANY_NAMEN + to.meta.title
    // }
  }

  // 2) 設定 canonical（只對前台 / 非 admin/editor）
  if (!to.path.startsWith('/admin') && !to.path.startsWith('/editor')) {
    let canonicalUrl = '';

    if (to.meta && to.meta.canonical) {
      canonicalUrl = to.meta.canonical;
    } else {
      // 沒有手動設定 canonical 的（例如動態路由），用 BASE_URL + to.path
      const path = to.path || '/';
      canonicalUrl = BASE_URL + path;
    }

    let link = document.querySelector("link[rel='canonical']");
    if (!link) {
      link = document.createElement('link');
      link.setAttribute('rel', 'canonical');
      document.head.appendChild(link);
    }
    link.setAttribute('href', canonicalUrl);
  }

  // 3) 清掉 no-scroll（如果有用到鎖卷軸的情境）
  document.body.classList.remove('no-scroll');
});

export default router;
